import script from "./NotFoundView.vue?vue&type=script&setup=true&lang=ts"
export * from "./NotFoundView.vue?vue&type=script&setup=true&lang=ts"

import "./NotFoundView.vue?vue&type=style&index=0&id=71cd9921&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-71cd9921"]])

export default __exports__